import MggpPlayer from 'mggp-player';
import messageHandlers from './message-handlers';
import * as messageFactory from './messageFactory';
import { toMIEvent } from './remapEventName';
import { ClientStorage } from './lib/client-storage/client-storage';
import { PreferenceRepo } from './lib/preference-repo';
import Interactive from './interactive/Interactive';
import { vendorsMatching } from './lib/vendors-matching.js';
import { Context } from './context.js';

import ControlsManager from './controls-manager/controls-manager.js';

MggpPluginInteractive.prototype = Object.create(MggpPlayer.Plugin.prototype);
MggpPluginInteractive.prototype.constructor = MggpPluginInteractive;

export default MggpPluginInteractive;

const REGISTER_REMOTE_EVENT = 'register_remote_event';
const UN_REGISTER_REMOTE_EVENT = 'un_register_remote_event';

/**
 * Does this property used anywhere?
 * @todo It seem that it's no usage. Check and remove.
 * @type {string}
 */
const AVAILABLE = 'available';
const ENABLE = 'enable';
const LOADED = 'loaded';
const READY = 'ready';
const STARTED = 'started';
const STOPPED = 'stopped';
const RESUMED = 'resumed';
const PAUSED = 'paused';
const SHOW_ELEMENT = 'showElement';
const HIDE_ELEMENT = 'hideElement';
const SHOW_CONTROLS = 'showControls';
const HIDE_CONTROLS = 'hideControls';
// const ERROR = 'error';
const ZONE = 'zone';
const TOKEN_EXPIRED = 'tokenExpired';

MggpPluginInteractive.events = {
  REGISTER_REMOTE_EVENT,
  UN_REGISTER_REMOTE_EVENT,
  SHOW_ELEMENT,
};

/**
 * @name MggpPluginInteractive
 * @constructor
 * @param pPlayer
 * @param {{enable: () => boolean, containerId: string, override: [string], configUrl: () => string, token: () => string}} pPlayerConfig
 * @todo Fix eslint issue
 */
// eslint-disable-next-line complexity
function MggpPluginInteractive (pPlayer, pPlayerConfig) {
  MggpPlayer.Plugin.apply(this, arguments);
  this.namespace = 'interactive:';
  const _config = {
    ...pPlayerConfig.interactive,
  };

  const _self = this;
  {
    // eslint-disable-next-line complexity
    function console (level) {
      return pPlayer?.config?.debug ?
        (...args) => global.console[level].call(global.console, '%cInteractive-plugin%c', 'font-weight: bold', 'font-weight: normal', ...args)
        : Function.prototype;
    }

    _self.log = console('log');
    _self.log.info = console('info');
    _self.log.debug = console('debug');
    _self.log.warn = console('warn');
    _self.log.error = console('error');
  }

  _config.isDeviceMatch = vendorsMatching(`${pPlayerConfig.deviceOS} ${pPlayerConfig.deviceYear}`);
  if (!_config.isDeviceMatch(_config.vendorsList)){
    return;
  }

  if (!_config.configUrl) {
    _self.log.error('Missing required property `configUrl`');
    return;
  }

  _config.container = document.getElementById(_config.containerId /* || "mggp-interactive-container"*/) || pPlayer.parentContainer;
  if (!_config.container) {
    _self.log.error('Missing required config property: "container"');
    return;
  }

  _self.on = function(eventName, listener) {
    pPlayer.on(_self.namespace + eventName, listener);
  };
  _self.off = function(eventName, listener) {
    pPlayer.off(_self.namespace + eventName, listener);
  };

  const emitPreference = this.emit.bind(this, 'preferences');
  // eslint-disable-next-line complexity
  const emitError = function (error = {}) {
    error.code = `interactive.${error.code ?? 'UNKNOWN'}`;
    error.message ??= 'interactive plugin failure';

    _self.log.error(error.message);

    _self.emit('error', {
      error,
      extendEvent (metEvent) {
        const metError = {
          code: error.code,
          info: error.message
        };
        /**
         * @type {Object} interactive
         * @property {[string]} interactive.type ожидается: «тип интерактива, на котором возникла ошибка»,
         *    но пока не ясно как его наполнить и почему он должен быть массивом
         * @property {number} interactiveState.state статус интерактива после ошибки,
         *    0 - отвалился
         *    1 - работает
         *    в настоящий момент фатальная ошибка может возникнуть только если:
         *      - не получилось создать фрейм вообще (нет конфига, таймаут, и т.д.)
         *      - интерактив явно сообщил что больше не может работать по какой-то причине
         *    поскольку сейчас, все сообщения из фрейма с не фатальными ошибками игнорируются,
         *    то возможен только вариант когда мы вообще не смогли запустить интерактив.
         */
        const interactive = {
          type: [],
          status: error.fatal === true ? 0 : 1
        };
        return Object.assign({}, metEvent, {
          error: metError,
          interactive
        });
      }
    });
  };

  // suspend flags, TODO: make it not so ugly
  {
    var _adShowing = false;
    var _messageMode = false;
    var _smallMode = false;
  }



  {
    _self.set = function (pName, ...args) {
      _self.player.set(_self.namespace + pName, ...args);
    };
    _self.get = function (pName) {
      return _self.player.get(_self.namespace + pName);
    };
    _self.registerProperty = function (pName, pDefaultValue, pNotResetable) {
      _self.player.registerProperty(this.namespace + pName, pDefaultValue, pNotResetable);
    };
  }

  let isReady = false;
  let isLoading = false;
  let isSuspend = false;
  let isStarted = false;


  const storage = new ClientStorage('preferences:interactive', pPlayerConfig.storage);
  const repo = _config.preferences = new PreferenceRepo(storage);

  repo.subscribe((_preferences, changes) => {
    /**
     * slightly weired, but for the moment every diff record will contain the same "new value"
     */
    const [ [ , , isEnable ] ] = changes;

    emitPreference({
      isEnable,
      extendEvent (metEvent) {
        const affectedList = changes.map(([ name ]) => name);
        const selfData = {
          type: affectedList,
          status: isEnable ? 1 : 0
        };
        return Object.assign({}, metEvent, { interactive: selfData });
      }
    });
  });

  // stupid, but implicit registering on first setting is worst
  _self.registerProperty('preferences', repo, true);

  _self.registerProperty(AVAILABLE, false, true);
  /**
   * Проблемное место, в некоторых случаях этот register может происходить позже
   * первого set.
   * На моменте этот кейс исправлен дополнительной регистрацие `interactive:zone`
   * в конструкторе loader.
   * TODO: Fix set/register/set property race,
   *   это можно исправить только в «подняв» вызов MggpLoader.initPlayer из callback
   *   в mggp-player-loader/src/index.js#initSkin, т.е. выполнять загрузку плагинов до запуска скина,
   *   но это требует пересмотра способа которым плагины используют контейнеры из скина
   */
  _self.registerProperty(ZONE, [], false);

  _self.player.on(REGISTER_REMOTE_EVENT, ({ data }) => messageHandlers.registerEvent(data));
  _self.player.on(UN_REGISTER_REMOTE_EVENT, messageHandlers.unRegisterEvent);

  /**
   * Вот таким причудливым способом можно получать из интерактива broadcast event для эмита в плеер.
   * В данном случае он использован что бы была возможность реализовать «не показывать больше»
   * при первом показе какого-то расширения.
   * @see messageHandlers.onBroadcastEvent
   */
  const remoteUpdatePreferenceEvent = 'interactive-ui:confirm-extension-on-first-view';
  _self.player.emit(REGISTER_REMOTE_EVENT, remoteUpdatePreferenceEvent);
  _self.player.on(remoteUpdatePreferenceEvent, (playerEvent) => {
    // expect: payloadEvent.type === remoteUpdatePreferenceEvent
    const {
      data,
    } = playerEvent;
    const preference = repo.getAll().find(({name}) => name === data.name);
    if(!preference){
      return;
    }
    preference.enable = data.enabled;
  });

  const context = new Context(pPlayer);
  const controls = new ControlsManager();

  if (!_config.token) {
    _self.on('action', function onceListener(event) {
      const {
        data
      } = event;
      if (data.event_type === 'change_token') {
        _config.token = data.new_token;
        _self.off('action', onceListener);
        _init();
      }
    });
  } else {
    _init();
  }

  /**while querying API;
- handle Unauthorized reject in edge connections;
- emit non-fatal error
   * @private
   */
  function _init(attemptCounter = 0) {
    if(attemptCounter > 9){
      // in additional to timeout, yet another prevention for repeatedly attempt to init
      const error = new Error('Too many attempts to init interactive');
      error.code = 'init-attempts-limit';
      error.fatal = true;
      emitError(error);
      return;
    }
    new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        const error = new Error('interactive loading timeout');
        error.code = 'load-timeout';
        error.fatal = true;
        reject(error);
      }, 15_000);
      const onResume = (interactive) => {
        // в это момент времени конфиг уже есть и фрейм создан, начинаем ждать отмашки про загрузку
        interactive.onLoad(() => {
          clearTimeout(timeout);
          isLoading = false;
          _self.emit(LOADED, { view: interactive.view.frame });
          resolve(interactive);
        });
      };
      const onError = (err) => {
        // very possible case: attempt to start having not-valid token
        if (err.code.includes('401')) {
          _self.on('action', function onceListener(event) {
            const {
              data
            } = event;
            if (data.event_type === 'change_token') {
              _config.token = data.new_token;
              _self.off('action', onceListener);
              _init(attemptCounter + 1);
            }
          });
          _self.emit(TOKEN_EXPIRED);
          return;
        }
        clearTimeout(timeout);
        isLoading = false;
        reject(err);
      };

      new Interactive(_config, pPlayer).then(onResume, onError);

      isLoading = true;
    })
      .then((interactive) => {
        setupMessageListeners(interactive);
        /* First set with actual, non-empty, preferences repo. With necessary `forceEmit`.  */
        _self.set('preferences', repo, true);
        repo.subscribe((preferences) => {
          preferences.forEach((option) => {
            interactive.action({
              event_type: "settings_changed",
              name: option.name,
              allowed: option.enable,
              isConfirmed: option.isConfirmed
            });
          });
        });


        const awaitReady = new Promise((resolve, reject) => {
          _self.on(READY, () => {
            clearTimeout(timeoutToReady);
            resolve();
          });
          const timeoutToReady = setTimeout(() => {
            const error = new Error('timeout: await interactive ready');
            error.code = 'ready-timeout';
            error.fatal = true;
            reject(error);
          }, 15_000);
        });

        interactive.create();

        return awaitReady;
      })
      .catch(emitError);
  }

  function handleNonFatalError(error) {
    if (error.code === 401){
      _self.emit(TOKEN_EXPIRED);
    }
  }

  function setupMessageListeners (interactive) {
    interactive.onError(onErrorMessage);

    function onErrorMessage (message) {
      const {
        data
      } = message;

      if (!data.fatal) {
        handleNonFatalError(data);
        return;
      }
      // stop and hide interactive frame
      interactive.view.hide();
      interactive.stop();

      // so far do not track any i9e errors to ET
      // return;

      // track error in ET
      const error = new Error(data.message);
      error.code = data.code ? `view.${data.code}` : 'view';
      error.fatal = data.fatal;
      emitError(error);
    }

    interactive.onReady(function () {
      isReady = true;
      setupPlayerEventsHandlers(interactive);
      interactive.resize(messageFactory.resize(_config, null, _self.get(ZONE)));

      context.get()
        .then(interactive.start)
        .then(() => {
          context.onChange(interactive.start);
          context.onReset(interactive.stop);
        });

      if (isSuspend) {
        interactive.pause();
      }

      _self.emit(READY, {
        // types: enabledExtensions,
        extendEvent (metEvent) {
          const enabledExtensions = repo.getAll()
            .filter((extension) => extension.enable)
            .map((extension) => extension.name);
          const selfData = {
            status: enabledExtensions.length > 0 ? 1 : 0,
            type: enabledExtensions
          };
          return Object.assign({}, metEvent, { interactive: selfData });
        }
      });

    });

    interactive.onStart(() => {
      isStarted = true;
      interactive.view.show();
      _self.set(AVAILABLE, true);
      _self.emit(STARTED);
    });

    interactive.onStop(() => {
      isStarted = false;
      interactive.view.hide();
      _self.set(AVAILABLE, false);
      _self.emit(STOPPED);
    });

    /**
     * @todo: Does it listen somebody for that events: paused/resumed?
     *    Does it make sense to emit it, due to pause state reflect "enable"
     */
    interactive.onPause(() => {
      _self.emit(PAUSED);
    });

    interactive.onResume(() => {
      _self.emit(RESUMED);
    });

    interactive.onShowElement(
      /**
       * @fires MggpPluginInteractive.events.SHOW_ELEMENT
       * @todo да как-же его правильно приписать?
       */
        // eslint-disable-next-line complexity
      (message) => {
        if (isSuspend) {
          return;
        }

        const {
          events,
          element,
        } = message.data;
        const { parameters } = element;

        /* TODO: Does it make sense to move this logic to loader,
             due to specific for site player? */
        if (parameters?.isTriggerPlayerPause) {
          pPlayer.set("ad:disable", true);
          pPlayer.set("skipPlayerInfoPanel", true);
          pPlayer.pause();
        }

        controls.showControl(element, events);

        if(element.element_id === 'button_emoji'){
          pPlayer.set('skin:showEmojiButton', true);
        }

        _self.emit(SHOW_ELEMENT, message.data);
      });

    // eslint-disable-next-line complexity
    interactive.onHideElement((message) => {
      const {
        element
      } = message.data;

      const parameters = element.parameters;

      if (parameters?.isTriggerPlayerPause) {
        pPlayer.play();
        pPlayer.set("ad:disable", false);
        pPlayer.set("skipPlayerInfoPanel", false);
      }

      controls.hideControl(message.data.element);

      if(element.element_id === 'button_emoji'){
        pPlayer.set('skin:showEmojiButton', false);
      }

      _self.emit(HIDE_ELEMENT, message.data);
    });

    interactive.onSetFocusable((message) => {
      const payload = message.data;
      _self.emit('focusable', payload.focusable);
    });

    interactive.onBlur((message) => {
      _self.emit('blur', message.data);
    });

    interactive.onShowControls((message) => {
      _self.emit(SHOW_CONTROLS, message.data);
    });

    interactive.onShowControls((message) => {
      _self.emit(HIDE_CONTROLS, message.data);
    });

    interactive.onClose(() => {
      _self.log.warn('Missing implementation for onClose');
    });

    interactive.onBroadcastEvent((message) => {
      messageHandlers.onBroadcastEvent.call(_self, message.data);
    });

    interactive.onReceiveAction((message) => {
      messageHandlers.onBroadcastEvent.call(_self, message.data);
    });

    interactive.onTrackEvent((message) => {
      /** emit ET event, omit handling in plugin met, must contain all necessary payload */
      pPlayer.emit(`met:${message.data.track}`, message.data.payload);
    });
  }

  /**
   *
   * @param {InteractiveBridge} interactive
   */
  function setupPlayerEventsHandlers (interactive) {
    pPlayer.on('property:ad:showing', function (pEvent) {
      _self.log.debug('property:ad:showing');
      _adShowing = pEvent.data;
      suspendInteractive(pEvent.data);
    });
    pPlayer.on('player:messageMode', function (pEvent) {
      _self.log.debug('player:messageMode');
      _messageMode = pEvent.data;
      suspendInteractive(Boolean(_messageMode));
    });
    pPlayer.on('property:smallMode', function (pEvent) {
      _self.log.debug('property:smallMode');
      _smallMode = pEvent.data;
      suspendInteractive(pEvent.data);
    });

    pPlayer.on('interactive:*', onInteractiveEvent);

    controls.onEvents(interactive.action);

    pPlayer.on('interactive:elementAction',
      /**
       * At the moment the only one expected element action is "click"
       * on emoji button in skin/UI.
       *
       * Any interaction with proxy controls should be handled by control's manager.
       *
       * @param {Object} pEvent
       */
      function (pEvent) {
      const {
        event,
        element,
      } = pEvent.data;
      const event_type = toMIEvent(event.type);
      event.type = event_type;

      interactive.action({
        event_type: event_type,
        element_id: element.element_id,
        // pass event to interactive almost AS IS
        event,
      });
    });

    pPlayer.on('property:' + _self.namespace + ZONE, function (ev) {
      const message = messageFactory.resize(_config, null, ev.data);
      interactive.resize(message);
    });

    pPlayer.on('property:interactive:position', (ev) => {
      const position = parseInt(ev.data, 10);
      if (Number.isFinite(position)) {
        interactive.time({
          position
        });
      }
    });

    /**
     *
     * @param {boolean} suspend
     * @todo fix eslint issue
     */
    // eslint-disable-next-line complexity
    function suspendInteractive (suspend) {
      if (isSuspend === suspend) {
        return;
      }

      if (isSuspend && (_smallMode || _adShowing || _messageMode)) {
        return;
      }

      isSuspend = suspend;

      if (isSuspend) {
        interactive.pause();
      } else {
        interactive.resume();
      }
    }

    /**
     * Seems redundant, does not make any work
     * @param pEvent
     */
    // eslint-disable-next-line complexity
    function onInteractiveEvent (pEvent) {
      const [ , name ] = pEvent.name.split(':');
      if (name === 'elementAction') {
        // has own listener setup
        return;
      }
      if (name === 'action' && pEvent.data.event_type === 'change_profile') {
        onProfileChanged();
        return;
      }
      if (interactive.hasOwnProperty(name)) {
        _self.log('onInteractiveEvent call', pEvent.name);
        interactive[name](pEvent.data);
      } else {
        _self.log.warn(`missing handler for event ${pEvent.name}`);
      }
    }

    /**
     * Handler for interactive:action event with event_type === 'change_profile'
     * emits by STV app
     * It should:
     * - load actual user preferences from player's storage interface
     * - notify interactive on possible preferences changes
     * - request new token
     */
    function onProfileChanged() {
      repo.reload();
      repo.getAll().forEach((option) => {
        interactive.action({
          event_type: "settings_changed",
          name: option.name,
          allowed: option.enable,
          isConfirmed: option.isConfirmed
        });
      });
      _self.emit(TOKEN_EXPIRED);
    }
  }
}
